import React from 'react'
import { connect } from 'react-redux'
import { defineMessages, FormattedMessage } from 'react-intl'
import { selectAddSpaceBudget } from 'src/store/selectors/home/equity'
import {
  Heading,
  ProConList,
  Pro,
  Info
} from 'src/Components/shared/Gem/GemDetail'

const AddSpace = props => (
  <div>
    <Heading>
      <FormattedMessage
        id='Homeowner.equity.addSpaceHeading'
        defaultMessage='Adding or finishing square footage may increase your home value while providing space to rent or house a family member.'
      />
    </Heading>

    <ProConList>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.addSpaceOne'
          defaultMessage='Qualifies as a home improvement so equity interest is tax-deductible'
        />
      </Pro>
      <Pro>
        <FormattedMessage
          id='Homeowner.equity.addSpaceTwo'
          defaultMessage='The extra space can be used for long or short-term rental if local ordinances allow'
        />
      </Pro>
      <Info>
        <FormattedMessage
          id='Homeowner.equity.addSpaceThree'
          defaultMessage='Talk to your agent to make sure an Accessory Dwelling Unit (ADU) on your property is lawful and determine how it will affect your home value'
        />
      </Info>
      <Info>
        <FormattedMessage
          id='Homeowner.equity.addSpaceFour'
          defaultMessage='Always consult a professional tax advisor to understand implications for your specific situation'
        />
      </Info>
    </ProConList>
  </div>
)

export default {
  GemContainer: connect(state => ({
    qaTag: 'addSpaceGem',
    amount: selectAddSpaceBudget(state)
  })),
  Detail: AddSpace,
  ...defineMessages({
    question: {
      id: 'Homeowner.equity.addSpaceQuestion',
      defaultMessage: 'Can I build an ADU?'
    },
    topic: {
      id: 'Homeowner.equity.addSpaceTopic',
      defaultMessage: 'adding more livable space'
    }
  })
}
